import Types from "@redux/types/auth/user-activation.type";

const initialState = {
    onRequest: false,
    activationState: "",
    isActivated: false,
    data: {},
};

const UserActivation = (state = initialState, action) => {
    switch (action.type) {
        case Types.USER_ACTIVATION_REQUEST: {
            return {
                ...state,
                onRequest: true,
            };
        }
        case Types.USER_ACTIVATION_CHECK: {
            const { activationState, statusMessage, token, data } = action.payload
            console.log(data);
            return {
                ...state,
                onRequest: false,
                activationState,
                statusMessage,
                token,
                data
            };
        }
        case Types.USER_ACTIVATION_ERROR: {
            const { activationState, statusMessage } = action.payload
            return {
                ...state,
                activationState, 
                statusMessage,
                onRequest: false,
            };
        }

        default: {
            return state;
        }
    }
};

export default UserActivation;
